module.exports = {"Aguascalientes":"AS","Baja California":"BC","Baja California Sur":"BS","Campeche":"CC","Chiapas":"CS","Chihuahua":"CH","Ciudad de México":"DF","Coahuila":"CL","Coahuila de Zaragoza":"CL","Colima":"CM","Durango":"DG","Guanajuato":"GT","Guerrero":"GR","Hidalgo":"HG","Jalisco":"JC","México":"MC","Michoacán":"MN","Morelos":"MS","Nayarit":"NT","Nuevo León":"NL","Oaxaca":"OC","Puebla":"PL","Querétaro":"QO","Quintana Roo":"QR","San Luis Potosí":"SP","Sinaloa":"SL","Sonora":"SR","Tabasco":"TC","Tamaulipas":"TS","Tlaxcala":"TL","Veracruz":"VZ","Yucatán":"YN","Zacatecas":"ZS"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/clave-estados.json
// module id = 442
// module chunks = 0